import { Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { WebsiteType } from 'src/app/types/website';
import { StatusBar, Style } from '@capacitor/status-bar';
import { AnalyticsService } from 'src/app/services/general/analytics.service';

@Component({
  selector: 'app-website',
  templateUrl: './website.page.html',
  styleUrls: ['./website.page.scss'],
})
export class WebsitePage implements OnInit, OnDestroy {

  @HostListener('window:resize', ['$event'])onResize(event: any) {
    this.setupContentHeight();
    this.setupViewportHeight();
  }
  /**
   * Watch screen orientation change for login slider setup
   */
  @HostListener('window:orientationchange', ['$event']) onOrientationChange(event: any) {
    this.setupContentHeight();
    this.setupViewportHeight();
  }
  
  @ViewChild('content', { read: ElementRef }) contentElement: ElementRef;
  
  /**
   * Account ID
   */
  accountId: string;
  /** Link ID */
  linkId: string;
  /**
   * Guest id
   */
  guestId: string;
  /**
   * Group id
   */
  groupId: string;
  /**
   * Ready flag
   */
  ready: boolean;

  contentHeight: number;

  websiteType: WebsiteType;

  /**
   * Constructor
   * @param route route
   */
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private analyticsService: AnalyticsService,
  ) { }

  /**
   * Initialize
   */
  ngOnInit() {
    this.watchRoute();
  }

  ngOnDestroy(): void {
    this.ready = false;
  }

  /**
   * Before view enter
   */
  ionViewWillEnter() {
    
  }

  ionViewDidEnter() {
    this.setupContentHeight();
    this.setupViewportHeight();
  }

  /**
   * Before view leave
   */
  ionViewWillLeave() {
    this.ready = false;
  }

  /**
   * Watch route
   */
  watchRoute() {
    this.route.params.subscribe((param: Params) => {
      this.ready = false;
      const route = this.router.getCurrentNavigation();
      const state = route?.extras?.state;

      if (param?.accountId) {
        this.accountId = param.accountId;
      } else if (state?.accountId) {
        this.accountId = state.accountId;
      }
      if (param?.guestId && param.guestId !== '0') {
        this.guestId = param.guestId;
      } else if (state?.guestId && state.guestId !== '0') {
        this.guestId = state.guestId;
      }
      if (param?.groupId && param?.groupId !== '0') {
        this.groupId = param.groupId;
      } else if (state?.groupId && state?.groupId !== '0') {
        this.groupId = state.groupId;
      }
      if (param?.linkId && param?.linkId !== '0') {
        this.linkId = param.linkId;
      } else if (state?.linkId && state?.linkId !== '0') {
        this.linkId = state.linkId;
      }
      if (param?.websiteType && param?.websiteType !== '0') {
        this.websiteType = param.websiteType;
      } else if (state?.websiteType && state?.websiteType !== '0') {
        this.websiteType = state.websiteType;
      }
      this.setupAnalytics(this.accountId, this.linkId, this.guestId, this.groupId, this.websiteType);
      this.ready = true;
    });
  }

  setupContentHeight() {
    this.contentHeight = this.getContentHeight();
  }

  getContentHeight(): number {
    return this.contentElement?.nativeElement?.offsetHeight ? this.contentElement.nativeElement.offsetHeight : window?.innerHeight ? window.innerHeight : 0;
  }

  setupViewportHeight() {
    if (window.innerHeight) {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    } 
  }

  setupAnalytics(accountId: string, linkId: string, guestId: string, groupId: string, websiteType: string) {
    this.analyticsService.setWeddingWebsite(accountId, linkId, guestId, groupId, websiteType);
  }

}
